/**
 * Format number with thousand separators
 */
export const formatNumber = (num: number): string => {
  return new Intl.NumberFormat('en-US').format(num);
};

/**
 * Format weight in tons with 2 decimal places (floored)
 */
export const formatWeight = (weight: number): string => {
  // 내림 처리: 소수점 2자리까지 내림
  const floored = Math.floor(weight * 100) / 100;
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(floored);
};
